export type NameFormat = 'firstName' | 'fullName' | 'initials';

export type NameParts = {
  firstName?: null | string;
  lastName?: null | string;
};

const filterAndJoin = (
  items: Array<null | string | undefined>,
  join = '',
): string => items.filter(Boolean).join(join);

/**
 * Formats a user's name to a specified format.
 */
export const formatName = (
  { firstName, lastName }: NameParts,
  format: NameFormat,
  fallback: string = 'User',
): string => {
  switch (format) {
    case 'firstName': {
      // Empty strings should fall back to fallback value.

      return firstName || fallback;
    }

    case 'fullName': {
      return filterAndJoin([firstName, lastName], ' ') || fallback;
    }

    case 'initials': {
      if (firstName) {
        return filterAndJoin([firstName[0], lastName?.[0]]).toUpperCase();
      } else {
        return '?';
      }
    }

    default: {
      throw new Error(`Unhandled name format: '${format}'`);
    }
  }
};
